export const getDocumentJpgUrl = (bucket: string, key: string) => {
  return `${process.env.REACT_APP_API_URL}/exploded-view/jpg?bucket=${bucket}&key=${key}`;
};
